import axios from "axios"

export const is404Error = (error: unknown) => {
  return axios.isAxiosError(error) && error.response?.status === 404
}

export const is401Error = (error: unknown) => {
  return axios.isAxiosError(error) && error.response?.status === 401
}

/** Every endpoint answers a failure with the same body; this reads one field of it. */
const readErrorField = (error: unknown, field: "message" | "code" | "requestId"): string | undefined => {
  if (!axios.isAxiosError(error)) {
    return undefined
  }

  const value = (error.response?.data as Record<string, unknown> | undefined)?.[field]

  return typeof value === "string" && value ? value : undefined
}

/**
 * The message the backend wrote. It is english and internal — a reason for the log rather
 * than for the visitor — so it belongs in the console, not on the screen.
 */
export const getApiErrorMessage = (error: unknown): string | undefined => readErrorField(error, "message")

/**
 * The reason as a code, when the backend named one. Its absence means the failure is
 * internal: a client knows the codes it can explain and treats everything else as a fault
 * of the service.
 */
export const getApiErrorCode = (error: unknown): string | undefined => readErrorField(error, "code")

/** What a developer finds the backend log entry of this exact failure by. */
export const getApiErrorRequestId = (error: unknown): string | undefined => readErrorField(error, "requestId")
